(() => {
  angular
    .module('gm.common.directives')
    .directive('gmKeydownBackspace', gmKeydownBackspaceDirective);

  function gmKeydownBackspaceDirective(
    $parse
  ) {
    'ngInject';

    return {
      restrict: 'A',
      link(scope, element, attrs) {
        const backspaceCb = $parse(attrs.gmKeydownBackspace);

        element.keydown((event) => {
          if (event.keyCode === 8) {
            backspaceCb(scope, {});
          }
        });
      }
    };
  }
})();
